<template>
    <div class="row stats">
        <div class="col-6 col-md">
            <div class="row">
                <div class="col-5">
                    <img src="@/assets/img/Highlights/Dealer.png" style="width:100%;"/>
                </div>
                <div class="col-7">
                    <p class="stats--title">Goods Issued<br>MD to D</p>
                    <p class="stats--value">{{ data != null ? numberWithCommas(data.gi_md_to_d) : 'Loading...' }}</p>
                </div>
            </div>
        </div>
        <div class="col-6 col-md">
            <div class="row">
                <div class="col-5">
                    <img src="@/assets/img/Highlights/Intransit.png" style="width:100%;"/>
                </div>
                <div class="col-7">
                    <p class="stats--title">In Transit<br>MD to Dealer</p>
                    <p class="stats--value">{{ data != null ? numberWithCommas(data.intransit_md_to_d) : 'Loading...' }}</p>
                </div>
            </div>
        </div>
        <div class="col-6 col-md">
            <div class="row">
                <div class="col-5">
                    <img src="@/assets/img/Highlights/DO Pending.png" style="width:100%;"/>
                </div>
                <div class="col-7">
                    <p class="stats--title">DO Pending</p>
                    <p class="stats--value">{{ data_do != null ? numberWithCommas(data_do[0].do_pending) : 'Loading...' }}</p>
                    <!-- <p class="stats--title mt-3">Virtual Stock</p>
                    <p class="stats--value">35</p> -->
                </div>
            </div>
        </div>
        <div class="col-6 col-md">
            <div>
                <div class="row">
                    <div class="col-5">
                        <img src="@/assets/img/Highlights/Dealer.png" style="width:100%;"/>
                    </div>
                    <div class="col-7" style="display: flex; flex-direction: column; justify-content: center;">
                        <p class="stats--title">Dealer Stock</p>
                        <p class="stats--value">{{ data != null ? numberWithCommas(data.dealer) : 'Loading...' }}</p>
                    </div>
                </div>
                <div class="row" :class="(mobile) ? 'h-50 borderBottom' : 'h-50'">
                    <div class="col-6 pl-4" style="height:60px;">
                        <p class="stats--title">Ready For Sales</p>
                        <p class="stats--value">{{ data != null ? numberWithCommas(data.ready_for_sales) : 'Loading...' }}</p>
                    </div>
                    <div class="col-6"  style="height:60px;">
                        <p class="stats--title">Stock SSU</p>
                        <p class="stats--value">{{ data != null ? numberWithCommas(data.ssu) : 'Loading...' }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-6 col-md">
            <div class="row">
                <div class="col-5">
                    <img src="@/assets/img/Highlights/Total.png" style="width:100%;"/>
                </div>
                <div class="col-7">
                    <p class="stats--title">Total Stock</p>
                    <p class="stats--value">{{ data != null ? numberWithCommas(parseInt(data.intransit_md_to_d) + parseInt(data.dealer) + parseInt(data.gi_md_to_d)) : 'Loading...' }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                
            }
        },
        props : ['data', 'data_do'],
        mounted () {

        },
        methods : {

        }
    }
</script>

<style scoped>
    .stats {
        padding: 2em 0;
    }

    .stats>.col-md {
        display: flex;
        align-items: center;
        padding: 0;
    }

    .stats .col-md:not(:last-child) {
        border-right: 1px solid #F2F2F2;
    }

    .stats>.col-md>.row>.col-5,
    .stats>.col-md>.row>.col-7 {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .stats>.col-md>.row>.col-7 {
        padding-top: 0;
        padding-bottom: 0;
    }

    .stats--title {
        font: normal normal 500 12px/13px Ubuntu;
        letter-spacing: 0;
        color: #707070;
        margin: 0 0 0.2em 0;
    }

    .stats--value {
        font: normal normal 500 22px/26px Ubuntu;
        letter-spacing: 0px;
        color:#707070;
        margin: 0;
    }
</style>